
/**
 * Logs details of CI build process to javascript console.
 */
export const logBuildInfo = () => {
    var head = document.getElementsByTagName('head')[0];
    const metaCollection = head.getElementsByTagName("meta");
    const metaElements = Array.from(metaCollection);

    console.group("BUILD INFO");
    console.info("ID:", metaElements.find((el) => el.name === "BUILD_ID")?.content);
    console.info("REF:", metaElements.find((el) => el.name === "BUILD_REF")?.content);
    console.info("WORKFLOW:", metaElements.find((el) => el.name === "BUILD_WORKFLOW")?.content);
    console.groupEnd();
};

export default logBuildInfo;